import { Injectable } from "@angular/core";
import $ from "../../assets/js/jquery-3.3.1.min";
import { AuthService } from "angularx-social-login";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  AppConfig,
  ContestModule,
  EventPrefixValue,
  LoginEventName,
  MatchMode,
} from "../app.config";
import { Router } from "@angular/router";
import { LoaderService } from "../loader/LoaderService";
import { Broadcaster } from "../app.broadcaster";
import { environment } from "../../environments/environment";
import { catchError, delay, retryWhen, take } from "rxjs/operators";
import { throwError } from "rxjs";
import { of } from "rxjs";
import { forkJoin } from "rxjs";
declare var Hansel: any;
declare var gapi: any;
declare var gtag: any;
declare var fbq: any;
import { StoredDataModel } from "../app.models";
declare var smartech: any;
declare var signalR: any;
declare var AF: any;
declare var clevertap: any;
@Injectable()
export class CommonService {
  fireStore: any;
  compareSwitch: boolean;
  isHtTandC: boolean;
  isHT = environment.isHT;
  matchInfo: any;
  information: any;
  email: any;
  loginTokenVal: any;
  element: any;
  localMatchInfo = {
    matchMode: MatchMode,
  };
  haveToCall1: boolean;
  deviceInfo: any;
  statusInfo: any;
  noOfMembers: any;
  playerListData: any;
  PlayersLists: any;
  pvtLeagueInfo: any;
  analytics: any;
  messaging: any;
  teamCount: any;
  showSupport: boolean = false;
  matchStatus: string;
  is3TC: boolean;
  isBackups: any;
  team1Flag: string;
  team1Color: string;
  team2Flag: string;
  team2Color: string;
  team3Flag: string;
  lineUpOut: boolean;
  label: any;
  apiUrl = environment.apiUrl;
  apiNewUrl = environment.apiNewUrl;
  apiTestUrl = environment.apiTestUrl;
  apiChangeUrl = environment.apiChangeUrl;
  apiTdsUrl = environment.apiTdsUrl;
  inProcess: boolean;
  matchType: boolean;
  completeProcess: boolean;
  scoreboard: any;
  categoryId: number;
  teamCampareTop: any;
  teamCampareTopMessage: any;
  team2Name: string;
  team3Name: string;
  team1Name: string;
  settings: any;
  timeformat: string;
  colorList: any;
  colorData: any;
  gapi: any;
  eventValue: any;
  quizOverData: any;
  signalRModel: any;
  connection: any;
  watcher: number;
  wdInfo: any;
  userData: any;
  isInning: boolean;
  desc: string;
  inviteCode: any;
  liveMatchTitle: any;
  relatedName: any;
  favTeamRankDataRes: boolean;
  favTeamDataLength: any;
  favTeamMaxCount: any;
  starTeamShow: boolean;
  StartDateDataShow: any;
  markAllRead: boolean;
  tossData: any;
  tossShow: boolean;
  eventListPanel: boolean;
  otpData: any;
  formatData: any;
  teamCountData: boolean = false;
  referCodeRes: any;
  ipData: any;
  leaderBoardCall: boolean = false;
  // isOpenModel: boolean;
  constructor(
    private socialAuthService: AuthService,
    private httpClient: HttpClient,
    private router: Router,
    private loaderService: LoaderService,
    private broadcaster: Broadcaster,
    public storedInfo: StoredDataModel
  ) {
    //  localStorage.removeItem('playingMode');
    this.markAllRead = true;
    this.initSettings();
    this.statusInfo = { text: 0, message: "", name: "", code: 0 };
    this.httpClient
      .get<{ ip: string }>("https://jsonip.com")
      .subscribe((data) => {
        this.ipData = data.ip;
      });
  }
  isAndroidDevice() {
    if (this.deviceInfo) {
      if (
        this.deviceInfo.os === "Android" ||
        this.deviceInfo.os === "Windows" ||
        this.deviceInfo.os === "Mac" ||
        this.deviceInfo.os === "Unknown"
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  isiOSDevice() {
    if (this.deviceInfo) {
      if (
        this.deviceInfo.os === "iOS" ||
        this.deviceInfo.os === "Windows" ||
        this.deviceInfo.os === "Mac" ||
        this.deviceInfo.os === "Unknown"
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  createCoffeeOrder(data) {
    //   console.log("++++",data);
    return new Promise<any>((resolve, reject) => {
      this.fireStore
        .collection("webEvents")
        .add(data)
        .then(
          (res) => {},
          (err) => reject(err)
        );
    });
  }

  webProperties(data) {
    return new Promise<any>((resolve, reject) => {
      this.fireStore
        .collection("webProperties")
        .add(data)
        .then(
          (res) => {},
          (err) => reject(err)
        );
    });
  }

  smallUpperCaseConverter(param, category, isLower): any {
    for (let e in param) {
      if (isLower) {
        param[e.toLowerCase()] = param[e];
      } else {
        param[e.toUpperCase()] = param[e];
      }
      delete param[e];
    }
    param["screen"] = category;
    return param;
  }
  logEvent(evnetName, param, category) {
    param["screen"] = category;
    param["AppId"] = 6;
    clevertap.event.push(evnetName, param);
    // const data = {
    //     EventName: evnetName,
    //     Parameter: JSON.stringify(param),
    //     timestamp: new Date()
    // };
    // this.createCoffeeOrder(data).then(res => {
    //     console.log('success store');
    // });

    if (this.analytics) {
      this.analytics.logEvent(evnetName, param);
    }
    setTimeout(() => {
      // that shoulbe be commented when go to live
      //  param = this.smallUpperCaseConverter(param, category, true)
      // end of code

      for (let e in param) {
        param[e.toLowerCase()] = param[e];
        delete param[e];
      }
      param["platform"] = "Web";
      param["screen"] = category;

      smartech("dispatch", evnetName, param);
    });
  }
  setLoginProperty(data, response) {
    this.setProfileCallSmartech(
      {
        "pk^userid": response.Response.UserId,
        LOGINTYPE: data.email
          ? EventPrefixValue.email
          : EventPrefixValue.mobile,
        email: data.email ? response.Response.Email : "",
        mobile: data.email ? "" : response.Response.Mobile,
        VERIFICATIONSTATUS: data.email
          ? EventPrefixValue.email
          : EventPrefixValue.mobile,
        DEVICEID: localStorage.getItem("deviceId"),
        FULLNAME: response.Response.Name,
      },
      environment.smartech.listIdentifier[4]
    );
    const userProperty = {
      UserID: response.Response.UserId,
      LoginType: data.email ? EventPrefixValue.email : EventPrefixValue.mobile,
      Email: data.email ? response.Response.Email : "",
      DeviceID: localStorage.getItem("deviceId"),
      FullName: response.Response.Name,
    };

    const userProperty2 = {
      UserID: response.Response.UserId,
      LoginType: data.email ? EventPrefixValue.email : EventPrefixValue.mobile,
      Email: data.email ? response.Response.Email : "",
      DeviceID: localStorage.getItem("deviceId"),
      FullName: response.Response.Name,
      VERIFICATIONSTATUS: data.email
        ? EventPrefixValue.email
        : EventPrefixValue.mobile,
      mobile: data.email ? "" : response.Response.Mobile,
    };
    this.setUserProperty(userProperty);
    //   clevertap.profile.push({ "Site": userProperty2 });
    this.setUserId(response.Response.UserId);
  }
  branchLogEvent(evnetName, param?) {
    setTimeout(() => {
      // branch.logEvent(evnetName, param, [], evnetName, (err) => {
      //     console.log(err);
      // });
    });
    AF("pba", "event", {
      eventType: "EVENT",
      eventCategory: "",
      eventName: evnetName,
      eventValue: param,
    });
  }
  getSignalRUrl() {
    let data: any;
    if (localStorage.getItem("signalRconnection")) {
      data = JSON.parse(localStorage.getItem("signalRconnection"));
    }
    return data;
  }
  signalRConnectionStart(baseUrl, matchid, leagueid?) {
    const promise = new Promise((resolve, reject) => {
      if (localStorage.getItem("user-info")) {
        this.signalRModel = {
          url: baseUrl + "ScorecardHub?MatchID=" + matchid,
        };
      }
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(this.signalRModel.url)
        .build();
      this.connection
        .start()
        .catch((err) => {
          resolve("error");
          return console.error(err);
        })
        .then(() => {
          this.connection.invoke("CreateOrJoinRoom", matchid).then(
            (response) => {
              if (!response.status) {
                this.scoreboard = null;
                console.log("error");
                resolve("error");
              } else {
                console.log("connected");
                resolve("success");
              }
            },
            (err) => {
              console.log("error");
              this.connection = null;
              resolve("error");
            }
          );
        });
    });
    return promise;
  }

  setUserProperty(properties) {
    // console.log("++",properties);
    // const data = {
    //     Property: JSON.stringify(properties),
    //     timestamp: new Date()
    // };
    // this.createCoffeeOrder(data).then(res => {
    //     console.log('success store');
    // });
    if (this.analytics) {
      this.analytics.setUserProperties(properties);
    }
    // setTimeout(() => {
    //     debugger
    //     Hansel.getUser().putAttribute(properties);
    //     // for (let e in properties) {
    //     //     properties[e.toLocaleLowerCase()] = properties[e];
    //     //     delete properties[e];
    //     // }
    //     smartech('contact', '15305', properties);
    // }, 100);
  }

  setProfileCallSmartech(properties, identifierName?) {
    // let data = {}
    // for (let e in properties) {
    //     properties[e.toUpperCase()] = properties[e];
    //     let propertyName = null
    //     if (e === 'pk^userid') {
    //         propertyName = 'pk^userid'
    //     } else {
    //         propertyName = e.toUpperCase()
    //     }
    //     // data = {
    //     //     PropertyName: propertyName,
    //     //     PropertyValue: properties[e],
    //     //     timestamp: new Date()
    //     // };
    //     // this.webProperties(data).then(res => {
    //     //     console.log('success store');
    //     // });
    //     delete properties[e];
    // }
    smartech("contact", "15305", properties);
  }

  setUserId(id) {
    if (this.analytics) {
      this.analytics.setUserId(id);
    }
    if (Hansel) {
      Hansel.getUser().setUserID(id);
    }
  }

  initSettings() {
    let getFromSplash = false;
    if (localStorage.getItem("settingInfo")) {
      const settings = JSON.parse(localStorage.getItem("settingInfo"));
      if (settings.colorTheme === 6) {
        getFromSplash = true;
      }
    }
    if (!getFromSplash) {
      this.colorList = AppConfig.colorList;
      if (localStorage.getItem("settingInfo")) {
        const settings = JSON.parse(localStorage.getItem("settingInfo"));
        this.colorData = this.colorList.find((o) => {
          return o.id === settings.colorTheme;
        });
        this.timeformat = settings.timeFormat;
        if (this.colorData) {
          $(":root").css({
            "--regular_color": this.colorData.regular,
            "--safe_color": this.colorData.safe,
          });
        } else {
          $(":root").css({
            "--regular_color": "#7B0041",
            "--safe_color": "#1141c1",
          });
        }
      } else {
        this.timeformat = "1";
        this.colorData = this.colorList[0];
        $(":root").css({
          "--regular_color": "#7B0041",
          "--safe_color": "#1141c1",
        });
      }
      this.checkColorAccordingToMode(this.colorData);
    }
  }
  checkColorAccordingToMode(item) {
    setTimeout(() => {
      if (this.getSportModeInfo() === 1) {
        const element: any = document.querySelector("meta[name='theme-color']");
        element.content = item ? item.regular : "#7B0041";
      } else {
        const element: any = document.querySelector("meta[name='theme-color']");
        if (element) {
          element.content = item ? item.safe : "#1141c1";
        }
      }
    }, 1000);
  }
  isLoggedIn() {
    if (localStorage.getItem("save_token")) {
      return true;
    } else {
      return false;
    }
  }
  dateFormat(deadline: any) {
    const month_names = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = new Date(deadline).getDate();
    const month = new Date(deadline).getMonth();
    let hours: any = new Date(deadline).getHours();
    let minutes: any = new Date(deadline).getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const strTime = hours + ":" + minutes + " " + ampm;
    const finalStr = day + " " + month_names[month] + " " + strTime;
    return finalStr;
  }
  stateInfo() {
    return this.httpClient.request("get", this.apiUrl + "users/Getstatelist");
  }
  stateInfo1() {
    return this.httpClient.request(
      "get",
      this.apiUrl + "users/GetAndrastatelist"
    );
  }
  forkRequest(data: any) {
    const promise = new Promise((resolve, reject) => {
      this.loaderService.show();
      const observables = [];
      for (const item of data) {
        let headersValue = new HttpHeaders();
        if (item.headerData) {
          item.headerData.push({ name: "AppType", value: 3 });
          if (item.headerData) {
            for (const inner of item.headerData) {
              headersValue = headersValue.set(
                inner.name,
                inner.value ? inner.value : 0
              );
            }
          }
        }
        observables.push(
          this.httpClient.request(item.methodType, this.apiUrl + item.url, {
            headers: headersValue,
            body: item.formData,
          })
        );
      }
      forkJoin(observables).subscribe(
        (response: any) => {
          this.loaderService.hide();
          for (const item of response) {
            this.checkTokenExpiry(item);
            if (!item.Status) {
              return reject(item.Message);
            }
          }
          resolve(response);
        },
        (error) => {
          this.loaderService.hide();
          return reject(this.label.message.errorMessage);
        }
      );
    });
    return promise;
  }

  forkRequest2(data: any) {
    const promise = new Promise((resolve, reject) => {
      this.loaderService.show();
      const observables = [];
      for (const item of data) {
        let headersValue = new HttpHeaders();
        if (item.headerData) {
          item.headerData.push({ name: "AppType", value: 3 });
          if (item.headerData) {
            for (const inner of item.headerData) {
              headersValue = headersValue.set(
                inner.name,
                inner.value ? inner.value : 0
              );
            }
          }
        }
        observables.push(
          this.httpClient.request(item.methodType, this.apiTdsUrl + item.url, {
            headers: headersValue,
            body: item.formData,
          })
        );
      }
      forkJoin(observables).subscribe(
        (response: any) => {
          this.loaderService.hide();
          for (const item of response) {
            this.checkTokenExpiry(item);
            if (!item.Status) {
              return reject(item.Message);
            }
          }
          resolve(response);
        },
        (error) => {
          this.loaderService.hide();
          return reject(this.label.message.errorMessage);
        }
      );
    });
    return promise;
  }
  sportTypeHeaderData(sportMode?) {
    let url = "en";
    if (localStorage.getItem("saveLanguage")) {
      url = JSON.parse(localStorage.getItem("saveLanguage")).language;
    }
    const userInfo = this.getTokenInfo(true);
    return [
      { name: "appVersion", value: "" },
      { name: "languageCode", value: url },
      { name: "userId", value: userInfo[0].value },
      {
        name: "appCode",
        value: sportMode ? sportMode : this.getSportModeInfo(),
      },
    ];
  }
  fetchmail(gapi) {
    const clientId = environment.gmailClientId;
    this.loaderService.show();
    gapi.load("client:auth2", () => {
      gapi.client
        .init({
          apiKey: environment.googleConsoleAPIkey,
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/people/v1/rest",
          ],
          clientId: clientId,
          scope:
            "profile email https://www.googleapis.com/auth/contacts.readonly",
        })
        .then((res) => {
          gapi.client.people.people.connections
            .list({
              resourceName: "people/me",
              pageSize: 2000,
              personFields: "names,phoneNumbers,emailAddresses",
            })
            .then(
              (response) => {
                this.loaderService.hide();
                if (response.result["connections"]) {
                  this.submitUserInfo(response.result);
                } else {
                  this.hideModel();
                  this.broadcaster.broadcast("pollMessage", {
                    type: "error",
                    message: "Do not have any gmail contact.",
                  });
                }
              },
              (error) => {
                this.loaderService.hide();
                this.broadcaster.broadcast("pollMessage", {
                  type: "error",
                  message: this.label.message.errorMessage,
                });
              }
            );
        });
    });
  }
  submitUserInfo(result) {
    if (result) {
      let finalResult = [];
      for (const item of result.connections) {
        const data = {
          name: item.names ? item.names[0].displayName : null,
          email: item.emailAddresses ? item.emailAddresses[0].value : null,
          number: item.phoneNumbers ? item.phoneNumbers[0].value : null,
        };
        finalResult.push(data);
      }
      const userInfo = this.getTokenInfo(true);
      this.apiRequest("users/save-friends", "post", userInfo, {
        FriendsData: JSON.stringify(finalResult),
      }).then(
        (response: any) => {
          localStorage.setItem("friend-list", "1");
          this.hideModel();
          this.router.navigate(["/contact-list"]).then(() => {
            window.location.reload();
          });
        },
        (error) => {
          this.broadcaster.broadcast("pollMessage", {
            type: "error",
            message: error,
          });
        }
      );
    }
  }

  apiRequest1(
    url: string,
    methodType: string,
    headerData?: any,
    formData?: any,
    hideLoader?: boolean,
    isCompUrl?: boolean
  ) {
    const promise = new Promise((resolve, reject) => {
      this.inProcess = true;
      if (!hideLoader) {
        this.loaderService.show();
      }
      let headersValue = new HttpHeaders();
      headerData.push({ name: "AppType", value: 3 });
      if (headerData) {
        for (const item of headerData) {
          if (typeof item.value === "boolean") {
            headersValue = headersValue.set(item.name, item.value);
          } else {
            headersValue = headersValue.set(
              item.name,
              item.value ? item.value : 0
            );
          }
        }
      }
      const endPoint = isCompUrl ? url : this.apiUrl + url;
      this.httpClient
        .request(methodType, endPoint, {
          headers: headersValue,
          body: formData,
        })
        .subscribe(
          (response: any) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.checkTokenExpiry(response);
            this.inProcess = false;
            this.statusInfo.code = 200;
            if (response.status) {
              return resolve(response);
            } else {
              this.statusInfo.message = response.Message;
              const message = this.statusInfo.message
                ? this.statusInfo.message
                : this.label.message.errorMessage;
              return reject(message);
            }
          },
          (error) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;
            this.statusInfo.code = error.status;
            this.statusInfo.name = error.name;
            this.statusInfo.text = error.statusText;
            this.statusInfo.message = error.message;
            return reject(this.label.message.errorMessage);
          }
        );
    });
    return promise;
  }
  apiRequest(
    url: string,
    methodType: string,
    headerData?: any,
    formData?: any,
    hideLoader?: boolean,
    isCompUrl?: boolean,
    responseType?: any
  ) {
    const promise = new Promise((resolve, reject) => {
      this.inProcess = true;
      if (!hideLoader) {
        this.loaderService.show();
      }

      let headersValue = new HttpHeaders();
      if (headerData) {
        if (!isCompUrl) {
          headerData.push({ name: "AppType", value: 3 });
        }
        for (const item of headerData) {
          headersValue = headersValue.set(
            item.name,
            item.value ? item.value : 0
          );
        }
      }

      const endPoint = isCompUrl ? url : this.apiUrl + url;

      this.httpClient
        .request(methodType, endPoint, {
          headers: headersValue,
          body: formData,
          responseType: responseType,
        })
        .pipe(
          retryWhen((errors) =>
            errors.pipe(
              delay(2000),
              take(3),
              catchError((error) => {
                if (error.status === 502) {
                  return of(error); // Emit the error to trigger retry
                }
                return throwError(error);
              })
            )
          )
        )
        .subscribe(
          (response: any) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;

            if (isCompUrl) {
              return resolve(response);
            } else {
              this.checkTokenExpiry(response);
              this.statusInfo.code = 200;

              if (response.Status || response.IsTimesUp) {
                if (response.IsTimesUp === true) {
                  this.hideModel();
                  setTimeout(() => {
                    this.winningBreakupModelOpen("time_up");
                    this.StartDateDataShow = "";
                  });
                  return resolve(response);
                } else {
                  return resolve(response);
                }
              } else {
                if (response && response.IsSuspended) {
                  return resolve(response);
                }
                this.statusInfo.message = response.Message;
                const message = this.statusInfo.message
                  ? this.statusInfo.message
                  : this.label.message.errorMessage;
                return reject(message); // Resolve with message instead of rejecting
              }
            }
          },
          (error) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;
            this.statusInfo.code = error.status;
            this.statusInfo.name = error.name;
            this.statusInfo.text = error.statusText;
            this.statusInfo.message = error.message;
            return reject(this.label.message.errorMessage);
          }
        );
    });

    return promise;
  }

  apiRequest2(
    url: string,
    methodType: string,
    headerData?: any,
    formData?: any,
    hideLoader?: boolean,
    isCompUrl?: boolean
  ) {
    const promise = new Promise((resolve, reject) => {
      this.inProcess = true;
      if (!hideLoader) {
        this.loaderService.show();
      }
      let headersValue = new HttpHeaders();
      if (headerData) {
        headerData.push({ name: "AppType", value: 3 });
        for (const item of headerData) {
          if (typeof item.value === "boolean") {
            headersValue = headersValue.set(item.name, item.value);
          } else {
            headersValue = headersValue.set(
              item.name,
              item.value ? item.value : 0
            );
          }
        }
      }
      const endPoint = isCompUrl ? url : this.apiNewUrl + url;
      this.httpClient
        .request(methodType, endPoint, {
          headers: headersValue,
          body: formData,
        })
        .subscribe(
          (response: any) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.checkTokenExpiry(response);
            this.inProcess = false;
            this.statusInfo.code = 200;
            if (response.Status) {
              return resolve(response);
            } else {
              this.statusInfo.message = response.Message;
              const message = this.statusInfo.message
                ? this.statusInfo.message
                : this.label.message.errorMessage;
              return reject(message);
            }
          },
          (error) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;
            this.statusInfo.code = error.status;
            this.statusInfo.name = error.name;
            this.statusInfo.text = error.statusText;
            this.statusInfo.message = error.message;
            return reject(this.label.message.errorMessage);
          }
        );
    });
    return promise;
  }

  apiRequest3(
    url: string,
    methodType: string,
    headerData?: any,
    formData?: any,
    hideLoader?: boolean,
    isCompUrl?: boolean
  ) {
    const promise = new Promise((resolve, reject) => {
      this.inProcess = true;
      if (!hideLoader) {
        this.loaderService.show();
      }
      let headersValue = new HttpHeaders();
      if (headerData) {
        headerData.push({ name: "AppType", value: 3 });
        for (const item of headerData) {
          if (typeof item.value === "boolean") {
            headersValue = headersValue.set(item.name, item.value);
          } else {
            headersValue = headersValue.set(
              item.name,
              item.value ? item.value : 0
            );
          }
        }
      }
      const endPoint = isCompUrl ? url : this.apiTestUrl + url;
      this.httpClient
        .request(methodType, endPoint, {
          headers: headersValue,
          body: formData,
        })
        .subscribe(
          (response: any) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.checkTokenExpiry(response);
            this.inProcess = false;
            this.statusInfo.code = 200;
            if (response.Status) {
              return resolve(response);
            } else {
              if (response && response.Status == false) {
                return resolve(response);
              }
              this.statusInfo.message = response.Message;
              const message = this.statusInfo.message
                ? this.statusInfo.message
                : this.label.message.errorMessage;
              return reject(message);
            }
          },
          (error) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;
            this.statusInfo.code = error.status;
            this.statusInfo.name = error.name;
            this.statusInfo.text = error.statusText;
            this.statusInfo.message = error.message;
            return reject(this.label.message.errorMessage);
          }
        );
    });
    return promise;
  }

  apiRequest4(
    url: string,
    methodType: string,
    headerData?: any,
    formData?: any,
    hideLoader?: boolean,
    isCompUrl?: boolean
  ) {
    const promise = new Promise((resolve, reject) => {
      this.inProcess = true;
      if (!hideLoader) {
        this.loaderService.show();
      }
      let headersValue = new HttpHeaders();
      if (headerData) {
        headerData.push({ name: "AppType", value: 3 });
        for (const item of headerData) {
          if (typeof item.value === "boolean") {
            headersValue = headersValue.set(item.name, item.value);
          } else {
            headersValue = headersValue.set(
              item.name,
              item.value ? item.value : 0
            );
          }
        }
      }
      const endPoint = isCompUrl ? url : this.apiChangeUrl + url;
      this.httpClient
        .request(methodType, endPoint, {
          headers: headersValue,
          body: formData,
        })
        .subscribe(
          (response: any) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.checkTokenExpiry(response);
            this.inProcess = false;
            this.statusInfo.code = 200;
            if (response.status) {
              return resolve(response);
            } else {
              if (response && response.status == false) {
                reject(response.message);
              }
              this.statusInfo.message = response.Message;
              const message = this.statusInfo.message
                ? this.statusInfo.message
                : this.label.message.errorMessage;
              return reject(message);
            }
          },
          (error) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;
            this.statusInfo.code = error.status;
            this.statusInfo.name = error.name;
            this.statusInfo.text = error.statusText;
            this.statusInfo.message = error.message;
            return reject(this.label.message.errorMessage);
          }
        );
    });
    return promise;
  }

  apiRequest5(
    url: string,
    methodType: string,
    headerData?: any,
    formData?: any,
    hideLoader?: boolean,
    isCompUrl?: boolean
  ) {
    const promise = new Promise((resolve, reject) => {
      this.inProcess = true;
      if (!hideLoader) {
        this.loaderService.show();
      }
      let headersValue = new HttpHeaders();
      if (headerData) {
        headerData.push({ name: "AppType", value: 3 });
        for (const item of headerData) {
          if (typeof item.value === "boolean") {
            headersValue = headersValue.set(item.name, item.value);
          } else {
            headersValue = headersValue.set(
              item.name,
              item.value ? item.value : 0
            );
          }
        }
      }
      const endPoint = isCompUrl ? url : this.apiTdsUrl + url;
      this.httpClient
        .request(methodType, endPoint, {
          headers: headersValue,
          body: formData,
        })
        .subscribe(
          (response: any) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.checkTokenExpiry(response);
            this.inProcess = false;
            this.statusInfo.code = 200;
            if (response.Status) {
              return resolve(response);
            } else {
              if (response && response.Status == false) {
                reject(response.message);
              }
              this.statusInfo.message = response.Message;
              const message = this.statusInfo.message
                ? this.statusInfo.message
                : this.label.message.errorMessage;
              return reject(message);
            }
          },
          (error) => {
            if (!hideLoader) {
              this.loaderService.hide();
            }
            this.inProcess = false;
            this.statusInfo.code = error.status;
            this.statusInfo.name = error.name;
            this.statusInfo.text = error.statusText;
            this.statusInfo.message = error.message;
            return reject(this.label.message.errorMessage);
          }
        );
    });
    return promise;
  }

  isImage(src) {
    const promise = new Promise((resolve, reject) => {
      const image = new Image();
      image.onerror = function () {
        return resolve(false);
      };
      image.onload = function () {
        return resolve(true);
      };
      image.src = src;
    });
    return promise;
  }
  public getSportTypeInfo() {
    if (localStorage.getItem("match_info")) {
      const matchInfo = JSON.parse(localStorage.getItem("match_info"));
      return matchInfo.matchType;
    }
  }
  public getSportModeInfo() {
    if (localStorage.getItem("match_info")) {
      const matchInfo = JSON.parse(localStorage.getItem("match_info"));
      return matchInfo.matchMode;
    }
  }
  getHomeCoachMark() {
    const introductions = [];
    if (this.label.home) {
      let data =
        "<h4>" +
        this.label.home.intro1.title +
        "</h4> <p>" +
        this.label.home.intro1.line1 +
        "</p><p>" +
        this.label.home.intro1.line2 +
        "</p><p>" +
        this.label.home.intro1.line3 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.home.intro2.title +
        "</h4> <p>" +
        this.label.home.intro2.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.home.intro3.title +
        "</h4> <p>" +
        this.label.home.intro3.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.home.intro4.title +
        "</h4> <p>" +
        this.label.home.intro4.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.home.intro5.title +
        "</h4> <p>" +
        this.label.home.intro5.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.home.intro6.title +
        "</h4> <p>" +
        this.label.home.intro6.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getSettingCoachMark() {
    const introductions = [];
    if (this.label.home) {
      const data =
        "<h4>" +
        this.label.home.intro5.title +
        "</h4> <p>" +
        this.label.home.intro5.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getSettingsCoachMark() {
    const introductions = [];
    if (this.label.profile) {
      const data =
        "<h4>" +
        this.label.settings.intro1.title +
        "</h4><p>" +
        this.label.settings.intro1.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getContestCategoryCoachMark() {
    const introductions = [];
    if (this.label.contest) {
      let data =
        "<h4>" +
        this.label.contest.intro1.title +
        "</h4><p>" +
        this.label.contest.intro1.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.contest.intro2.title +
        "</h4> <p>" +
        this.label.contest.intro2.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getAllContestCoachMark() {
    const introductions = [];
    if (this.label.allContest) {
      const data =
        "<h4>" +
        this.label.allContest.intro1.title +
        "</h4><p>" +
        this.label.allContest.intro1.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getCreateTeamsCoachMark() {
    const introductions = [];
    if (this.label ? this.label.createTeams : false) {
      let data =
        "<h4>" +
        this.label.createTeams.intro1.title +
        "</h4><p>" +
        this.label.createTeams.intro1.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.createTeams.intro2.title +
        "</h4> <p>" +
        this.label.createTeams.intro2.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getProfileCoachMark() {
    const introductions = [];
    if (this.label.profile) {
      let data =
        "<h4>" +
        this.label.profile.intro1.title +
        "</h4><p>" +
        this.label.profile.intro1.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.profile.intro2.title +
        "</h4> <p>" +
        this.label.profile.intro2.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.profile.intro5.title +
        "</h4> <p>" +
        this.label.profile.intro5.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  getMyProfileCoachMark() {
    const introductions = [];
    if (this.label.profile) {
      let data =
        "<h4>" +
        this.label.profile.intro3.title +
        "</h4><p>" +
        this.label.profile.intro3.line1 +
        "</p>";
      introductions.push(data);
      data =
        "<h4>" +
        this.label.profile.intro4.title +
        "</h4> <p>" +
        this.label.profile.intro4.line1 +
        "</p>";
      introductions.push(data);
      return introductions;
    }
  }
  public languageAPICall() {
    let url = "en";
    if (localStorage.getItem("saveLanguage")) {
      url = JSON.parse(localStorage.getItem("saveLanguage")).language;
    }
    this.httpClient
      .request("get", "assets/language/" + url + ".json?ver=3.13")
      .subscribe((response: any) => {
        this.label = response;
      });
  }
  public getLanguageLabel() {
    let url = "en";
    if (localStorage.getItem("saveLanguage")) {
      url = JSON.parse(localStorage.getItem("saveLanguage")).language;
    }
    return this.httpClient.request("get", "assets/language/" + url + ".json");
  }
  public getSavedLanguageInfo() {
    if (localStorage.getItem("saveLanguage")) {
      return JSON.parse(localStorage.getItem("saveLanguage"));
    } else {
      return { language: "en", isSaved: false };
    }
  }
  public createSafeCss1() {
    const isSafeCssExist = document.getElementById("safeCss");
    if (!isSafeCssExist) {
      const x = document.createElement("LINK");
      x.setAttribute("rel", "stylesheet");
      x.setAttribute("id", "safeCss");
      x.setAttribute("type", "text/css");
      x.setAttribute("href", "assets/css/safe.css");
      document.head.appendChild(x);
      this.element = document.querySelector("meta[name='theme-color']");
      this.element.content = this.colorData.regular
        ? this.colorData.regular
        : "#7b0041";
    }
  }
  public removeSafeCss() {
    const x = document.getElementById("safeCss");
    if (x) {
      x.parentNode.removeChild(x);
      this.element = document.querySelector("meta[name='theme-color']");
      this.element.content = this.colorData.safe
        ? this.colorData.safe
        : "#1141c1";
    }
  }
  public createSafeCss() {
    this.localMatchInfo.matchMode = MatchMode;
    if (localStorage.getItem("match_info")) {
      this.matchInfo = JSON.parse(localStorage.getItem("match_info"));
      if (this.localMatchInfo.matchMode.regular === this.matchInfo.matchMode) {
        const isSafeCssExist = document.getElementById("safeCss");
        if (!isSafeCssExist) {
          this.element = document.querySelector("meta[name='theme-color']");
          this.element.content = this.colorData.safe
            ? this.colorData.safe
            : "#1141c1";
          const x = document.createElement("LINK");
          x.setAttribute("rel", "stylesheet");
          x.setAttribute("id", "safeCss");
          x.setAttribute("type", "text/css");
          x.setAttribute("href", "assets/css/safe.css");
          document.head.appendChild(x);
        }
      }
    }
  }
  public socialGmailLogin() {
    this.gapi = gapi;
    this.gapi.load("auth2", () => {
      this.gapi.auth2
        .init({
          client_id: environment.gmailClientId,
          cookie_policy: "none",
          scope: "profile email",
        })
        .then(
          (response) => {
            const auth2 = this.gapi.auth2.getAuthInstance();
            auth2.signIn().then((res: any) => {
              const currentUserInfo = res.getBasicProfile();
              const data = {
                email: currentUserInfo.getEmail(),
                userreferCode: "",
                name: currentUserInfo.getName(),
                id: currentUserInfo.getId(),
                idToken: res.wc.access_token,
              };
              // this.commonSocialColletedData(data, 'users/gmaillogin', 'google');
            });
          },
          (error) => {
            // this.socialFailedEvent(2, error);
          }
        );
    });
  }
  // public socialSignIn(socialPlatform: string) {
  //     let socialPlatformProvider;
  //     let url;
  //     if (socialPlatform === 'facebook') {
  //         socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
  //         url = 'users/facebooklogin';
  //     } else if (socialPlatform === 'google') {
  //         socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
  //         url = 'users/gmaillogin';
  //     }
  //     this.socialAuthService.signIn(socialPlatformProvider).then(
  //         (userData: any) => {
  //             // this.commonSocialColletedData(userData, url, socialPlatformProvider);
  //         }, (error) => {
  //             this.socialFailedEvent(1, error);
  //         }
  //     );
  // }
  // socialFailedEvent(type, error) {
  //     this.analytics.logEvent('social_signup_failed', {
  //         signup_type: type,
  //         error_code: error.status,
  //         failed_message: error.message
  //     });
  // }
  addCashWithdrawlEvent(eventName, data) {
    this.logEvent(
      eventName,
      {
        TotalBalance: data.TotalAmount,
        WinningAmount: data.Winning,
        UnutilizedBalance: data.Unutilized,
        CashBonus: data.Bonus,
      },
      EventPrefixValue.wallet
    );
  }
  // commonSocialColletedData(userData, url, socialPlatform) {
  //     this.loaderService.show();
  //     this.apiRequest('users/usercheck', 'get', [
  //         {name: 'email', value: userData.email},
  //         {name: 'sId', value: userData.id},
  //     ]).then((response: any) => {
  //         if (response.Response === '0') {
  //             localStorage.setItem('social_item', JSON.stringify(userData));
  //             this.router.navigate(['/register']);
  //         } else {
  //             this.socialLoginIn(userData, url, socialPlatform).subscribe((response1: any) => {
  //                 this.loaderService.hide();
  //                 if (response1.Status) {
  //                     if (response1.Response.MobileVerify && response1.Response.IsFirstTime) {
  //                         localStorage.setItem('save_token', JSON.stringify(response1.Response));
  //                         this.setUserProperty({LoginType: userData.idToken ? EventPrefixValue.gmail : EventPrefixValue.fb});
  //                         this.setProfileCallSmartech(
  //                             {
  //                                 'pk^userid': response.Response.UserId,
  //                                 LOGINTYPE: userData.idToken ? EventPrefixValue.gmail : EventPrefixValue.fb
  //                             }, environment.smartech.listIdentifier[1]
  //                         );
  //                         smartech('identify', response1.Response.UserId);
  //                         this.router.navigate(['/menu/home']);
  //                     } else {
  //                         this.checkStateVarification(response1, '', userData);
  //                     }
  //                 }
  //             }, (error) => {
  //                 this.loaderService.hide();
  //                 this.analytics.logEvent('login_failed', {
  //                     user_name: socialPlatform.name,
  //                     error_code: this.statusInfo.code,
  //                     failed_message: this.statusInfo.message
  //                 });
  //             });
  //         }
  //     });
  // }

  parsingDeepLinking(returnUrl) {
    let matchId: string;
    if (returnUrl) {
      if (returnUrl.indexOf("myteam11deeplink") >= 0) {
        matchId = returnUrl.replace("myteam11deeplink/", "");
        if (matchId.indexOf("screen") >= 0) {
          matchId = matchId.replace("screen/", "");
          if (matchId === "favouriteTeam") {
            this.router.navigate(["/favorite-team"]);
          } else if (matchId === "main") {
            this.router.navigate(["/menu/home"]);
          } else if (matchId === "notification") {
            this.router.navigate(["/notification"]);
          } else if (matchId === "wallet") {
            this.router.navigate(["/menu/wallet"]);
          } else if (matchId === "addcash") {
            this.router.navigate(["/add-cash"]);
          } else if (matchId === "profile") {
            this.router.navigate(["/my-profile"]);
          } else if (matchId === "refer") {
            this.router.navigate(["/refer-n-earn"]);
          } else if (matchId === "support") {
            this.router.navigate(["/support"]);
          } else if (matchId === "feedback") {
            this.router.navigate(["/feedback"]);
          } else if (matchId === "coupon") {
            this.router.navigate(["/passes-and-coupons"]);
          } else if (matchId === "scratch") {
            this.router.navigate(["/scratch-card"]);
          } else if (matchId === "recent") {
            this.router.navigate(["/recent-transactions"]);
          } else if (matchId === "settings") {
            this.router.navigate(["/settings"]);
          } else if (matchId === "rank") {
            this.router.navigate(["/series-rank"]);
          }
        } else if (matchId.indexOf("sports") >= 0) {
          matchId = matchId.replace("sports/", "");
          this.router.navigate(["/menu/home"], {
            queryParams: { sports: matchId },
          });
        } else if (matchId.indexOf("action") >= 0) {
          matchId = matchId.replace("action/", "");
          this.router.navigate(["/more/auto"], {
            queryParams: { action: matchId },
          });
        } else if (matchId.indexOf("contest-category") >= 0) {
          matchId = matchId.replace("contest-category/", "");
          this.router.navigate(["/sports/contest-category/" + matchId]);
        } else if (matchId.indexOf("createTeam") >= 0) {
          matchId = matchId.replace("createTeam/", "");
          this.router.navigate(["/sports/create-team/" + matchId]);
        } else if (matchId.indexOf("web") >= 0) {
          matchId = matchId.replace("web/", "");
          this.router.navigate(["/more/auto"], {
            queryParams: { pathRoute: matchId },
          });
          //    this.router.navigate(['/menu/home']);
        } else if (matchId.indexOf("external") >= 0) {
          matchId = matchId.replace("external/", "");
          window.open(matchId, "_blank");
          this.router.navigate(["/menu/home"]);
        } else {
          this.router.navigate(["/menu/home"]);
        }
      } else {
        this.router.navigate([returnUrl]);
      }
    }
  }

  checkStateVarification(
    response: any,
    returnUrl?: string,
    userData?: any,
    page?: string
  ) {
    if (!response.Response.MobileVerify) {
      localStorage.setItem("save_token", JSON.stringify(response.Response));
      if (page) {
        this.router.navigate(["/verify-otp"], { queryParams: { page: page } });
      } else {
        this.router.navigate(["/verify-otp"]);
      }
    } else {
      this.loaderService.show();
      this.apiRequest3("profile/v1/get", "get", [
        { name: "ExpireToken", value: response.Response.ExpireToken },
        { name: "AuthExpire", value: response.Response.AuthExpire },
        { name: "UserId", value: response.Response.UserId },
      ]).then((response1: any) => {
        if (localStorage.getItem("save_team")) {
          const data = JSON.parse(localStorage.getItem("save_team"));
          this.loaderService.show();
          const headersValue = new HttpHeaders()
            .set("matchID", data.matchid)
            .set("teamId", "0")
            .set("playersave", JSON.stringify(data.playerList))
            .set("UserId", response.Response.UserId)
            .set("ExpireToken", response.Response.ExpireToken)
            .set("AuthExpire", response.Response.AuthExpire);
          this.httpClient
            .request("post", this.apiUrl + "player/userteamsave", {
              headers: headersValue,
            })
            .subscribe(
              () => {
                this.loaderService.hide();
                smartech("identify", response.Response.UserId);
                localStorage.setItem(
                  "save_token",
                  JSON.stringify(response.Response)
                );
                localStorage.removeItem("players_list");
                localStorage.removeItem("setState");
                localStorage.removeItem("save_team");
                this.router.navigate([
                  "/sports/contest-category/" + data.matchid,
                ]);
              },
              (error) => {
                localStorage.setItem(
                  "save_token",
                  JSON.stringify(response.Response)
                );
                localStorage.removeItem("players_list");
                localStorage.removeItem("setState");
                localStorage.removeItem("save_team");
                this.router.navigate([
                  "/sports/contest-category/" + data.matchid,
                ]);
              }
            );
        } else {
          localStorage.setItem("save_token", JSON.stringify(response.Response));
          smartech("identify", response.Response.UserId);
          if (returnUrl) {
            this.parsingDeepLinking(returnUrl);
          } else {
            this.signInTrack("/menu/home");
          }
        }
        if (userData) {
          this.logEvent(
            LoginEventName.name8,
            {
              UserName: userData.name,
              Email: userData.email,
              //  UserId:response.Response.UserId
            },
            EventPrefixValue.login
          );
          this.setUserProperty({
            LoginType: userData.idToken
              ? EventPrefixValue.gmail
              : EventPrefixValue.fb,
          });
          this.setProfileCallSmartech(
            {
              "pk^userid": response.Response.UserId,
              LOGINTYPE: userData.idToken
                ? EventPrefixValue.gmail
                : EventPrefixValue.fb,
            },
            environment.smartech.listIdentifier[5]
          );
        } else {
          this.logEvent(
            LoginEventName.name8,
            {
              UserName: response.Response.Name,
              Email: response.Response.Email,
              UserId: response.Response.UserId,
              MobileNo: response.Response.Mobile,
              LoginType: "Email",
              ReferCode: this.referCodeRes ? this.referCodeRes : "Blank",
              IpAddress: this.ipData ? this.ipData : "Blank",
            },
            EventPrefixValue.login
          );
          this.setUserProperty({ LoginType: EventPrefixValue.email });
          const value: number =
            page === "login"
              ? environment.smartech.listIdentifier[5]
              : environment.smartech.listIdentifier[0];
          this.setProfileCallSmartech(
            {
              "pk^userid": response.Response.UserId,
              LOGINTYPE: EventPrefixValue.email,
            },
            value
          );
        }
        // clevertap.onUserLogin.push({
        //     "Site": {
        //         "Name": response.Response.Name,            // String
        //         "Identity": response.Response.UserId,              // String or number
        //         "Email": response.Response.Email,         // Email address of the user
        //         "Phone": "+91" + response.Response.Mobile,           // Phone (with the country code)
        //         "Gender": response.Response.Gender,                     // Can be either M or F
        //         "DOB": new Date(JSON.parse(response.Response.DOB)),                 // Date of Birth. Date object
        //         // optional fields. controls whether the user will be sent email, push etc.
        //     }
        // })
        this.branchLogEvent(LoginEventName.name8, {
          userId: response.Response.UserId,
        });
        this.setUserId(response.Response.UserId);
      });
    }
  }
  setVerificationProperty(data, data1) {
    let value: string;
    if (data.MobileNumber) {
      value = EventPrefixValue.mobile;
    }
    if (data1.isFirstTime) {
      value = EventPrefixValue.teamName;
    }
    if (data.EmailVerify) {
      value = EventPrefixValue.email;
    }
    if (data.PanVerify) {
      value = EventPrefixValue.pan;
    }
    if (data.BankVerify) {
      value = EventPrefixValue.accNo;
    }
    this.setUserProperty({ VerificationStatus: value });
    this.setProfileCallSmartech(
      {
        "pk^userid": data1.UserId,
        VERIFICATIONSTATUS: value,
      },
      environment.smartech.listIdentifier[1]
    );
  }
  socialLoginIn(item: any, url: string, plateform: string) {
    const headersValue = new HttpHeaders()
      .set("userreferCode", item.userreferCode ? item.userreferCode : "")
      .set("email_address", item.email)
      .set("token", "123456")
      .set("web", "1")
      .set("tokenFireBase", "123456")
      .set(plateform === "google" ? "GmailID" : "FacebokkId", item.id)
      .set(
        plateform === "google" ? "GmailAccessToken" : "FacebookAccessToken",
        plateform === "google" ? item.idToken : item.authToken
      );
    return this.httpClient.request("post", this.apiUrl + url, {
      headers: headersValue,
    });
  }
  winningBreakUpEvent(item) {
    const userInfo = this.getTokenInfo(true);
  }
  checkTokenExpiry(response: any) {
    if (response.TokenExpire) {
      localStorage.removeItem("save_token");
      this.broadcaster.broadcast("setBgOrNot", false);
      this.router.navigate(["/login"]);
    }
  }
  showIsXi() {
    if (this.lineUpOut) {
      return true;
    } else {
      return false;
    }
  }
  bindClass(item) {
    if (this.lineUpOut) {
      if (item.IsXi) {
        return "Playing";
      } else if (item.IsNotXi) {
        return "not_playing";
      } else {
        return "";
      }
    } else {
      if (item.IsInjured) {
        return "ruled_out";
      } else if (item.IsNewAddition) {
        return "new_addition";
      } else if (item.LastIsXi) {
        return "In Last Playing";
      } else {
        return "";
      }
    }
  }
  bindText(item) {
    if (this.lineUpOut) {
      if (item.IsXi) {
        return "Playing";
      } else if (item.IsNotXi) {
        return "Not Playing";
      } else {
        return "";
      }
    } else {
      if (item.IsInjured) {
        return "Injured / Ruled Out";
      } else if (item.IsNewAddition) {
        return "New Addition";
      } else if (item.LastIsXi) {
        return "In Last Playing";
      } else {
        return "";
      }
    }
  }
  getTokenInfo1(UserId, ExpireToken, AuthExpire) {
    return [
      { name: "UserId", value: UserId ? UserId : 0 },
      { name: "ExpireToken", value: ExpireToken ? ExpireToken : 0 },
      { name: "AuthExpire", value: AuthExpire ? AuthExpire : 0 },
    ];
  }
  getTokenInfo(headerFormat) {
    if (headerFormat) {
      if (localStorage.getItem("save_token")) {
        const userInfo = JSON.parse(localStorage.getItem("save_token"));
        return [
          { name: "UserId", value: userInfo ? userInfo.UserId : 0 },
          { name: "ExpireToken", value: userInfo ? userInfo.ExpireToken : 0 },
          { name: "AuthExpire", value: userInfo ? userInfo.AuthExpire : 0 },
        ];
      } else {
        return [
          { name: "UserId", value: 0 },
          { name: "ExpireToken", value: 0 },
          { name: "AuthExpire", value: 0 },
        ];
      }
    } else {
      if (localStorage.getItem("save_token")) {
        return JSON.parse(localStorage.getItem("save_token"));
      }
    }
  }
  requestMediator(method, apiUrl, headersValue?) {
    return new Promise((resolve, reject) => {
      this.loaderService.show();
      this.httpClient
        .request(method, this.apiUrl + apiUrl, {
          headers: headersValue,
        })
        .subscribe(
          (response: any) => {
            this.checkTokenExpiry(response);
            if (response.Status) {
              resolve(response.Response); // pass values;
            } else {
              reject("error");
            }
            this.loaderService.hide();
          },
          (error) => {
            this.loaderService.hide();
            reject("error");
          }
        );
    });
  }
  setWidth() {
    return {
      width: $(".left_view").width() + "px",
    };
  }
  setHeight2() {
    return {
      height:
        $(".PopfullHeight, .pointsystemPopup").css(
          "height",
          $(window).innerHeight() - 40
        ) + "px",
      width: $(".left_view").width() + "px",
    };
  }
  setWidth1(image) {
    if (image) {
      return {
        "background-image": "url(" + image + ")",
        width: $(".left_view").width() + "px",
      };
    } else {
      return this.setWidth();
    }
  }
  gtagReportConversion(url) {
    if (environment.production) {
      const callback = function () {
        if (typeof url !== "undefined") {
          window.location = url;
        }
      };
      fbq("track", "AddToCart");
      gtag("event", "conversion", {
        send_to: "AW-814996156/xw6ACIncmcMBELy1z4QD",
        event_callback: callback,
      });
      return false;
    } else {
      window.location = url;
      //  this.router.navigate([url]);
    }
  }
  playMatch(url) {
    if (environment.production) {
      fbq("track", "StartTrial");
      gtag("event", "conversion", {
        send_to: "AW-814996156/iEFNCKL-ssMBELy1z4QD",
        event_callback: () => {
          if (typeof url !== "undefined") {
            this.router.navigate([url]);
          }
        },
      });
      return false;
    } else {
      this.router.navigate([url]);
    }
  }
  signInTrack(url) {
    if (environment.production) {
      fbq("track", "Contact");
      gtag("event", "conversion", {
        send_to: "AW-814996156/yd05CPeImsMBELy1z4QD",
        event_callback: () => {
          if (typeof url !== "undefined") {
            this.router.navigate([url]);
          }
        },
      });
      return false;
    } else {
      this.router.navigate([url]);
    }
  }
  signupTrack(url) {
    if (environment.production) {
      fbq("track", "Complete Registration");
      gtag("event", "conversion", {
        send_to: "AW-814996156/1Gg8CMyHmsMBELy1z4QD",
        event_callback: () => {
          if (typeof url !== "undefined") {
            this.router.navigate([url]);
          }
        },
      });
      return false;
    } else {
      this.router.navigate([url]);
    }
  }
  accordian(event) {
    $(".btn_plus").click(function () {
      if ($(event.currentTarget).parent().parent().hasClass("active")) {
        $(event.currentTarget).parent().parent().removeClass("active");
        $(event.currentTarget)
          .parent()
          .parent()
          .children(".pnal_body")
          .slideUp(500);
      } else {
        const trans = $(event.currentTarget).attr("data-target");
        $(`${trans}` + "> .accordion_in").removeClass("active");
        $(`${trans}` + "> .accordion_in > .pnal_body").slideUp(500);
        $(event.currentTarget).parent().parent().addClass("active");
        $(event.currentTarget)
          .parent()
          .parent()
          .children(".pnal_body")
          .slideDown(500);
      }
    });
  }
  setPadding() {
    // setTimeout(() => {
    //     if ($(window).width() < 589) {
    if ($(".left_view footer").height()) {
      return {
        "padding-top": $(".left_view header").height() + "px",
        "padding-bottom": $(".left_view footer").height() + "px",
        // 'height': $(window).innerHeight() + 'px'
      };
    } else {
      return {
        "padding-top": $(".left_view header").height() + "px",
      };
    }
    // } else {
    //     return {
    //         'padding-top': $('.left_view header').height() + 'px',
    //         'padding-bottom': $('.left_view footer').height() + 'px',
    //         'height': 'calc(100vh - 40px)'
    //     };
    // }
    // });
  }
  setPadding1() {
    return {
      "padding-top": $(".left_view header").height() + "px",
    };
  }
  setWebStyle() {
    return {
      height: "calc(100vh - " + $(".left_view header").height() + "px)",
      width: "100%",
      border: "none",
    };
  }
  setHeight(increseValue) {
    const full_height = $(".left_view").innerHeight();
    const top_spac = $(".tab_scrolling_div").offset().top;
    let footer_h = $(".left_view  footer").innerHeight();
    const header_h = $(".left_view  header").innerHeight();
    if (!footer_h) {
      footer_h = 0;
    }
    const div_heigh =
      full_height - top_spac - footer_h - header_h + increseValue;
    return {
      height: div_heigh + "px",
    };
  }
  tabAnimation(tab_id: string, tabNoKey: string) {
    // setTimeout(() => {
    const tabNo = $(tabNoKey).find(".active").index();
    const tabWidth = $(tab_id).width();
    return {
      "-webkit-transform": "translateX(" + -tabWidth * tabNo + "px)",
      "-moz-transform": "translateX(" + -tabWidth * tabNo + "px)",
      transform: "translateX(" + -tabWidth * tabNo + "px)",
    };
    // }, 500);
  }
  tabAnimation1($event) {
    const tab_id = $($event.currentTarget).attr("data-target");
    const tab_num = $($event.currentTarget).parent().index();
    const li = $($event.currentTarget)
      .parent()
      .parent()
      .children()
      .removeClass("active");
    $($event.currentTarget).parent().addClass("active");
    $(`${tab_id}`).css({
      "-webkit-transform":
        "translateX(" +
        -$(`${tab_id}` + "> .tab-data").width() * tab_num +
        "px)",
      "-moz-transform":
        "translateX(" +
        -$(`${tab_id}` + "> .tab-data").width() * tab_num +
        "px)",
      transform:
        "translateX(" +
        -$(`${tab_id}` + "> .tab-data").width() * tab_num +
        "px)",
    });
    $(`${tab_id}` + "> .tab-data").removeClass("active");
    const tab_num_data = $($event.currentTarget).parent().index() + 1;
    $(`${tab_id}` + "> .tab-data:nth-child(" + tab_num_data + ")").addClass(
      "active"
    );
  }
  loader(item) {
    const filled = item.noofMembers - item.totalJoined;
    const percent = (filled * 100) / item.noofMembers;
    return {
      width: 100 - percent + "%",
    };
  }
  bindCss() {
    return {
      top: $(".player_box").innerHeight() + "px",
    };
  }
  winningBreakupModelOpen(id) {
    $("#" + id).css({
      bottom: "20px",
      visibility: "visible",
      opacity: "1",
    });
    $(".full_view").addClass("modal-show");
  }
  openOfferPopUp(id) {
    $("#" + id).css({
      width: this.setWidth(),
      bottom: "30px",
      opacity: "1",
      visibility: "visible",
      display: "block",
    });
    $(".full_view").addClass("modal-show");
  }
  isModelOpened() {
    return $(".full_view").hasClass("modal-show");
  }
  hideModel() {
    $(".our_modal").each(function () {
      $(this).css({
        bottom: -$(this).innerHeight(),
        visibility: "hidden",
        opacity: "0",
      });
    });
    $(".full_view").removeClass("modal-show");
  }
  onScroll(event) {
    if ($(".scroll_class").offset()) {
      const scroll_class =
        $(".scroll_class").offset().top - $(".left_view header").height() - 20;
      if (0 >= scroll_class) {
        $(".scroll_class").addClass("scroll_active");
      } else {
        $(".scroll_class").removeClass("scroll_active");
      }
      const scrolling_class = event.currentTarget.scrollTop;
      if (scrolling_class >= 20) {
        if (
          event.currentTarget.className.indexOf("scroling_div_active") === -1
        ) {
          event.currentTarget.className += " scroling_div_active";
        }
      } else {
        event.currentTarget.className = event.currentTarget.className.replace(
          "scroling_div_active",
          ""
        );
      }
    }
  }
}
